<template>

  <div class="row" v-if="canShowView">
    <div class="col-12">
      <el-card title="Compass">

        <div class="table-layout-container">

          <div class="row">
            <div class="col-12">
              <div></div>
              <l-pagination class="pagination-no-border float-right" v-model="currentState.pagination.currentPage" :per-page="currentState.pagination.perPage" :total="currentState.pagination.total" @input="handlePageChange"></l-pagination>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-2 col-12">
              <div class="row">
                <div class="mb-3 col-12 col-sm-12">
                  <el-select style="width: 100%" v-model="currentState.pagination.perPage" placeholder="Per pagina" @change="handlePerPageChange">
                    <el-option v-for="item in componentSettings.pagination.perPageOptions" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="col-sm-10 col-12">
              <div class="row">
                <div class="col-sm-3 col-12 mb-3">
                  <el-select multiple style="width: 100%" v-model="currentState.searchFields.selected" placeholder="Dove cerco?" @change="handleSearchFieldsChange">
                    <el-option v-for="(option, index) in searchFields" :value="option.searchFields" :label="option.label" :key="index">
                    </el-option>
                  </el-select>
                </div>

                <div class="col-sm-3 col-12 mb-3">
                  <el-select style="width: 100%" v-model="currentState.searchTypeSelected" placeholder="Come cercare?" @change="handleSearchTypeChange">
                    <el-option v-for="(item, index) in searchTypeOptions" :key="index" :label="item.label" :value="index"></el-option>
                  </el-select>
                </div>

                <div class="col-12 col-sm-4">
                  <el-input style="width: 100%" type="search" placeholder="Cerca" v-model="currentState.searchQuery" @change="handleSearchChange" addon-right-icon="fa fa-search" />
                </div>

                <div class="col-sm-2 col-12 mb-3 no-padding-left-desktop">
                  <button class="btn btn-outline btn-danger btn-outline col-12" style="padding: 8px 0px; width: 100%" @click="resetFilters">
                            <span class="btn-label">
                               <i class="fa fa-times"></i>
                            </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="col-12" v-loading="loading">
              <el-table class="table-striped" :data="tableData" border style="width: 100%" :default-sort="currentState.currentSorting" @sort-change="handleSortChange">

                <template v-for="column in tableColumns">

                  <el-table-column v-if="column.custom === 'id'" :type="column.type" :fixed="column.fixed" :key="column.label" :width="calculateTableWidth(column)" :prop="column.prop" :sortable="column.sortable" :label="column.label">
                    <template #default="props">
                      <span v-if="props.row && props.row.id" class="td-strong">{{props.row.id}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="column.custom === 'order_id'" :type="column.type" :fixed="column.fixed" :key="column.label" :width="calculateTableWidth(column)" :prop="column.prop" :sortable="column.sortable" :label="column.label">
                    <template #default="props">
                      <router-link class="dark-link" :to="{path:'/ordini/lista/modifica/' + props.row.order_id}">
                        <span v-if="props.row && props.row.order_id" class="td-strong">{{props.row.order_id}}</span>
                      </router-link>
                    </template>
                  </el-table-column>

                  <el-table-column v-else-if="column.custom === 'numero_pratica'" :type="column.type" :fixed="column.fixed" :key="column.label" :width="calculateTableWidth(column)" :prop="column.prop" :sortable="column.sortable" :label="column.label">
                    <template #default="props">
                      <span v-if="props.row && props.row.numero_pratica">{{props.row.numero_pratica}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column v-else-if="column.custom === 'stato_pratica'" :type="column.type" :fixed="column.fixed" :key="column.label" :width="calculateTableWidth(column)" :prop="column.prop" :sortable="column.sortable" :label="column.label">
                    <template #default="props">
                      <span v-if="props.row && props.row.stato_pratica">{{props.row.stato_pratica}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column v-else-if="column.custom === 'codice_autorizzativo'" :type="column.type" :fixed="column.fixed" :key="column.label" :width="calculateTableWidth(column)" :prop="column.prop" :sortable="column.sortable" :label="column.label">
                    <template #default="props">
                      <span v-if="props.row && props.row.codice_autorizzativo">{{props.row.codice_autorizzativo}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column v-else-if="column.custom === 'created_at'" :type="column.type" :fixed="column.fixed" :key="column.label" :width="calculateTableWidth(column)" :prop="column.prop" :sortable="column.sortable" :label="column.label">
                    <template #default="props">
                      <span v-if="props.row && props.row.created_at">{{dateToItalian(props.row.created_at, false)}} </span>
                    </template>
                  </el-table-column>

                </template>

              </el-table>
            </div>
          </div>

          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-3">
            <div class="">
              <p class="card-category" v-if="!loading && currentState.pagination.total > 0">Mostro da <strong>{{currentState.pagination.from}}</strong> a <strong>{{currentState.pagination.to}}</strong> su <strong>{{currentState.pagination.total}}</strong> totali</p>
            </div>
            <l-pagination class="pagination-no-border"
                          v-model="currentState.pagination.currentPage"
                          :per-page="currentState.pagination.perPage"
                          :total="currentState.pagination.total"
                          @input="handlePageChange">
            </l-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
  import { Pagination as LPagination, Breadcrumb, BreadcrumbItem } from 'src/components/index'

  export default {
    components: {
      LPagination,
      Breadcrumb,
      BreadcrumbItem,
    },
    watch: {
    },
    computed: {},
    data () {
      return {
        componentSettings: {
          singleFieldSearch: true,
          searchTypeOption: 0,
          tableSort: {prop: 'id', order: 'descending'},
          myComponentName: 'Compass',
          minimumPermissionLevel: 200,
          pagination: {
            perPageOptions: [5, 10, 25, 50, 100]
          },
          searchFieldsDefault: ['id']
        },
        currentState: {
          currentSorting: {prop: 'id', order: 'descending'},
          searchFields: {
            selected: ['id'],
            lastSelection: ['id']
          },
          pagination: {
            perPage: 25,
            currentPage: 1,
            lastLoadedPage: 1,
            total: 0,
            from: 0,
            to: 0,
            showedItems: 0
          },
          searchQuery: '',
          searchTypeSelected: 0
        },
        searchFields: [
          {searchFields: 'id', label: 'ID'},
          {searchFields: 'order_id', label: 'ID ordine'}
        ],
        searchTypeOptions: [
          {searchType: '0', label: 'Contiene'},
          {searchType: '2', label: 'Inizia per'},
          {searchType: '1', label: 'È uguale a'}
        ],
        tableColumns: [
          {
            prop: 'id',
            label: 'ID',
            percentWidth: 8,
            sortable: 'custom',
            showTooltip: true,
            fixed: true,
            type: 'default',
            first: true,
            custom: 'id'
          },
          {
            prop: 'order_id',
            label: 'Ordine',
            percentWidth: 20,
            sortable: false,
            showTooltip: true,
            fixed: false,
            type: 'default',
            custom: 'order_id'
          },
          {
            prop: 'numero_pratica',
            label: 'Numero pratica',
            percentWidth: 21,
            sortable: false,
            showTooltip: true,
            fixed: false,
            type: 'default',
            custom: 'numero_pratica'
          },
          {
            prop: 'stato_pratica',
            label: 'Stato pratica',
            percentWidth: 21,
            sortable: false,
            showTooltip: true,
            fixed: false,
            type: 'default',
            custom: 'stato_pratica'
          },
          {
            prop: 'codice_autorizzativo',
            label: 'Codice autorizzativo',
            percentWidth: 15,
            sortable: false,
            showTooltip: true,
            fixed: false,
            type: 'default',
            custom: 'codice_autorizzativo'
          },
          {
            prop: 'created_at',
            label: 'Creata il',
            percentWidth: 15,
            sortable: true,
            showTooltip: true,
            fixed: false,
            type: 'default',
            custom: 'created_at'
          }
        ],
        loading: false,
        tableData: [],
        canShowView: false
      }
    },
    methods: {
      getSaveStateConfig () {
        return {
          'cacheKey': this.componentSettings.myComponentName,
          'saveProperties': ['currentState']
        }
      },
      handlePageChange (page) {
        if (page === this.currentState.pagination.lastLoadedPage) return
        this.updateData()
      },
      handlePerPageChange (perPage) {
        this.updateData({page: 1, limit: perPage})
      },
      handleSearchChange () {
        this.updateData()
      },
      handleSearchFieldsChange (pIndex) {
        if (this.currentState.searchFields.selected.length < 1) {
          this.currentState.searchFields.selected = this.currentState.searchFields.lastSelection
          return
        }
        if (this.currentState.searchFields.selected.length > 1 && this.componentSettings.singleFieldSearch) {
          this.currentState.searchFields.selected = [this.currentState.searchFields.selected[this.currentState.searchFields.selected.length - 1]]
        }
        this.currentState.searchFields.lastSelection = this.currentState.searchFields.selected
        this.updateData()
      },
      handleSearchTypeChange (pIndex) {
        if (this.currentState.searchQuery === '') return
        this.updateData()
      },
      handleSortChange (pSortType) {
        let cSort = this.findColumnSort(pSortType)
        if (pSortType.prop === null) {
          this.currentState.currentSorting = this.componentSettings.tableSort
        } else {
          if (this.currentState.currentSorting.prop === cSort && this.currentState.currentSorting.order === pSortType.order) {
            return
          }
          this.currentState.currentSorting = {prop: cSort, order: pSortType.order}
        }
        this.updateData()
      },
      resetFilters (pReload = true) {
        this.currentState.searchQuery = ''
        this.currentState.currentSorting = JSON.parse(JSON.stringify(this.componentSettings.tableSort))
        this.currentState.searchTypeSelected = 0
        this.currentState.pagination.perPage = 25
        this.currentState.pagination.currentPage = 1
        this.currentState.searchFields.selected = this.componentSettings.searchFieldsDefault
        this.clearSavedState()
        if (pReload) this.updateData()
      },
      updateData (params) {
        this.loading = true
        if (!params) params = {}
        params = Object.assign(params, this.$store.getters.apiCommon, {page: this.currentState.pagination.currentPage, limit: this.currentState.pagination.perPage})
        if (this.currentState.searchQuery !== '') {
          params = Object.assign(params, {search: this.currentState.searchQuery, search_fields: this.currentState.searchFields.selected, search_type: this.searchTypeOptions[this.currentState.searchTypeSelected].searchType})
        }
        if (this.currentState.currentSorting !== null) {
          params = Object.assign(params, {orderby: this.currentState.currentSorting.prop, order_direction: this.convertOrderDirection(this.currentState.currentSorting.order)})
        }
        this.$store.dispatch('compass/logs', params).then((response) => {
          this.loading = false
          this.tableData = response.data.compass_logs.data
          this.currentState.pagination.total = response.data.compass_logs.total
          this.currentState.pagination.lastLoadedPage = this.currentState.pagination.currentPage
          this.currentState.pagination.showedItems = response.data.count
          this.currentState.pagination.from = response.data.compass_logs.from
          this.currentState.pagination.to = response.data.compass_logs.to
        }).catch(e => {
          this.loading = false
          this.showLoadingError(e)
        })
      }
    },
    created: function () {
      if (!this.checkIfPermissionLevelIsAtLeast(this.componentSettings.minimumPermissionLevel, true)) return
      this.canShowView = true
      this.updateData()
    },
    destroyed: function () {
      this.$off()
    }
  }
</script>
<style>
</style>
